import api from '../api'// 导入api接口

const getUser = 'http://47.101.184.183:8080/gbc/demo/tu';
const getTableBackUp = 'http://47.101.184.183:8080/gbc/demo/tb';
const getTablePlicies = 'http://47.101.184.183:8080/gbc/demo/tp';
const getTableSchedules = 'http://47.101.184.183:8080/gbc/demo/ts';

export default {
  getUserApi: getUser,
  getTableBackUpApi: getTableBackUp,
  getTablePliciesApi: getTablePlicies,
  getTableSchedulesApi: getTableSchedules,
  data() {
    return {
      userRole: ''
    }
  },
  methods: {
    formatDate(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m;
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    strToArr(str) {
      // 日程里面的周天转换为数组
      str = str.substring(1, str.length - 1).replace(/\"/g, "");
      var arr = new Array();
      arr = str.split(",");
      return arr.sort();//按照字典排序
    },
    async getUserRole(userName) {
      await api.user.selectUser("owner", userName)
        .then(res=>{
          this.userRole = res.data;
        })
      return this.userRole;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js